import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/dist/query/react";
import {prepareAuthHeaders} from "../../utils/prepareAuthHeaders";

export const employeeApi = createApi({
    reducerPath: 'employeeApi',
    keepUnusedDataFor: 1,
    baseQuery: fetchBaseQuery({
        baseUrl: '/Employee',
        prepareHeaders: prepareAuthHeaders,
    }),
    endpoints: (builder) => ({
        listEmployees: builder.query({
            query: () => ({
                url: `/ListEmployees`,
                method: 'GET'
            }),
        }),
        getLaboratoryWorkDisciplinesOfEmployee: builder.query({
            query: () => ({
                url: `/LaboratoryWorkDisciplinesOfEmployee`,
                method: 'GET'
            }),
        }),
        getGroupsOfEmployeeDiscipline: builder.query({
            query: ({disciplineId, lessonType}) => ({
                url: `/GroupsOfEmployeeDiscipline`,
                method: 'GET',
                params: {disciplineId, lessonType}
            }),
        }),
        listEmployeePersons: builder.query({
            query: () => ({
                url: `/ListEmployeePersons`,
                method: 'GET'
            }),
        }),
        searchEmployeesWithJobs: builder.query({
            query: (fullName) => ({
                url: `/SearchEmployeesWithJobs`,
                method: 'GET',
                params: {fullName}
            }),
        }),
        getScheduleDiagnostics: builder.query({
            query: ({fullName, date}) => ({
                url: `/ScheduleDiagnostics`,
                method: 'GET',
                params: {fullName, date}
            }),
        }),
        getChairWorkloads: builder.query({
            query: ({tchName, yearStart, chairName, contingent, page}) => ({
                url: `/ChairWorkloads`,
                method: 'GET',
                params: {tchName, yearStart, chairName, contingent, page}
            }),
        }),
    }),
});

export const {
    useListEmployeesQuery,
    useGetLaboratoryWorkDisciplinesOfEmployeeQuery,
    useGetGroupsOfEmployeeDisciplineQuery,
    useListEmployeePersonsQuery,
    useLazySearchEmployeesWithJobsQuery,
    useLazyGetScheduleDiagnosticsQuery,
    useLazyGetChairWorkloadsQuery
} = employeeApi;
